// CheckoutForm.js
import React, { Component } from 'react';
import { injectStripe } from 'react-stripe-elements';
import firebase from "firebase";
import { connect } from 'react-redux'
import { addStripeToken } from '../../store/actions/projectActions'
// import AddressSection from './AddressSection';
import CardSection from './CardSection';
import PaymentModal from './PaymentModal';
import M from 'materialize-css';
import { withRouter } from "react-router";
import { Redirect } from 'react-router-dom';
import VerifyEmail from '../layout/VerifyEmail';

M.AutoInit();


class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalShown: false,
    };
  }

  state = {
    clicked: false,
    plan: null,
    instance: null,
    isModalShown: false

  }


  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }

  handleSubmit = (auth, profile, plan) => e => {

    e.preventDefault();
    this.setState({ clicked: true })
    this.props.stripe.createToken({ name: profile.email })
      .then((token) => {
        this.props.addStripeToken(token)
        this.setState({ token: token })
        this.setState({ clicked: false })
        this.setState({ methodExists: true })
        firebase.firestore().collection('stripe_customers').doc(auth.uid).collection('charges').add({
          source: token.token.card.id,
          plan: plan
        });

        this.setState({ isModalShown: true })

      })
      .catch((err) => {
        this.setState({ clicked: false })
        console.log(err)
      })
  };



  render() {
    const { auth, profile } = this.props

    if (!auth.uid) {
      return <Redirect to={'/signin'} />
    } else if (auth.uid && !profile.esign && profile.isLoaded) {
      return <Redirect to={'/mysign'} />
    }
    if (auth.emailVerified) {

      let currentplan

      let nextbutton = (<div className="preloader-wrapper big active">
        <div className="spinner-layer spinner-teal-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div><div className="gap-patch">
            <div className="circle"></div>
          </div><div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>);

      if (!this.state.clicked) {
        if (!this.state.plan) {
          nextbutton = (
            <div className="input-field">
              <button disabled className="btn teal lighten-1 z-depth-0">UPGRADE ACCOUNT</button>
            </div>)

        } else if (this.state.plan === "1" || this.state.plan === "2") {
          nextbutton = (
            <div className="input-field">
              <button className="btn teal lighten-1 z-depth-0">UPGRADE ACCOUNT</button>
            </div>)
        }
      }

      if (!profile.plan) {
        currentplan = "Free"
      } else if (profile.plan === 1) {
        currentplan = "Pro"
      } else if (profile.plan === 2) {
        currentplan = "Premium"
      }

      let planDetail;
      if (this.state.plan === "1") {
        planDetail = (

          <div className="row">
            <div className="col m6 s6 offset-m5">
              <table>
                <tbody>
                  <tr>
                    <td>Secure IPFS storage</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Unlimited NDA signs</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>10 EUR a month</td>
                    <td className="teal-text">Pro</td>
                  </tr>
                  <tr>
                    <td>You can create upto 10 NDAs a month</td>
                    <td className="teal-text">Pro</td>
                  </tr>
                  <tr>
                    <td>Customer support</td>
                    <td className="teal-text">Pro</td>
                  </tr>
                  <tr>
                    <td>First month FREE</td>
                    <td><i className="teal-text material-icons">grade</i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      } else if (this.state.plan === "2") {
        planDetail = (

          <div className="row">
            <div className="col m6 s6 offset-m5">
              <table>
                <tbody>
                  <tr>
                    <td>Secure IPFS storage</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Unlimited NDA signs</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>15 EUR a month</td>
                    <td className="teal-text">Premium</td>
                  </tr>
                  <tr>
                    <td>You can create unlimited NDAs</td>
                    <td className="teal-text">Premium</td>
                  </tr>
                  <tr>
                    <td>Customer support</td>
                    <td className="teal-text">Premium</td>
                  </tr>
                  <tr>
                    <td>First month FREE</td>
                    <td><i className="teal-text material-icons">grade</i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      }

      let contentdiv;

      if (profile.plan) {

        contentdiv = (
          <div></div>
        )

      } else {

        contentdiv = (
          <div className="row">

            <div className="input-field">
              <select className="browser-default" onChange={this.handleChange} id="plan">
                <option value="" disabled selected>Choose your plan</option>
                <option value="1">Pro: 10 EUR a month</option>
                <option value="2">Premium: 15 EUR a month</option>
              </select>
            </div>

            {planDetail}
            <CardSection />
            {nextbutton}
          </div>
        )
      }


      return (


        < div className="grey lighten-5" >
          <div className="container">
            <div className="row"></div>
            <form onSubmit={this.handleSubmit(auth, profile, this.state.plan)} className="white">
              <h5 className="grey-text text-darken-3">Upgrade Account</h5>

              <div className="row">
                Your current plan is {currentplan}</div>
              <div className="row"></div>
              <div className="row"></div>
              <div className="row"></div>
              {contentdiv}
            </form>
          </div>

          {this.state.isModalShown &&
            <PaymentModal onClose={() => {
              this.setState({
                isModalShown: false
              })
              this.props.history.push('/dashboard')
            }} />
          }

        </div >

      );
    } else if (auth && !auth.emailVerified) {
      return (
        <VerifyEmail auth={auth} />
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addStripeToken: (token) => dispatch(addStripeToken(token))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectStripe(CheckoutForm)));